import React,{Component} from 'react';
import "../style.less"
import {NavBar, Toast, TextareaItem,Modal} from "antd-mobile";
import {disaudit} from "../../../../service/homeService";
import {connect} from "react-redux";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class AuditDetail extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data:{},
            note:"",
            modal:false,
            imgData:""
        }
    }
    componentDidMount() {
        console.log('====================================');
        console.log('this.props.history.location.state',this.props.history.location.state);
        console.log('====================================');
       this.setState({data:this.props.history.location.state})
    }
    inputChange = key =>(e) =>{
        this.setState({ [key]: e })
    };
    submitBtn(){
        const {note} = this.state;
        const params={
            token: this.props.userInfo.token,
            data:{
                id:this.state.data.id,
                note:note,
                status:1,
            }
        }
        disaudit(params).then((res) => {
            if(res.data.code == "0000"){
                Toast.info('操作成功',2,()=> this.props.history.goBack());
            }else {
                Toast.info(res.data.msg,3)
            }
        })
       
    }
    submitBtn2(){
        const {note} = this.state;
        const params={
            token: this.props.userInfo.token,
            data:{
                id:this.state.data.id,
                note:note,
                status:4,
            }
        }
        disaudit(params).then((res) => {
            if(res.data.code == "0000"){
                Toast.info('操作成功',2,()=> this.props.history.goBack());
            }else {
                Toast.info(res.data.msg,3)
            }
        })
       
    }
 
    render(){
        return(
            <div className="auditDetail">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >自检单审核详情</NavBar>

                <div className="warp">
                    <div className="con">
                        {
                            this.state.data.safeCheckList?(
                                <div className="item">
                            <span>例检单：</span>
                            <div className="imgbox">
                                {
                                    this.state.data.safeCheckList && this.state.data.safeCheckList.map((res)=>(
                                        <img onClick={()=>{this.setState({modal:true,imgData:res})}} src={res} className="imgData"></img>
                                    ))
                                }
                            </div>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.selfInspection?(
                                <div className="item">
                                <span>自检单：</span><img className="imgData" onClick={()=>{
                                this.setState({modal:true,imgData:this.state.data.selfInspection})
                            }} src={this.state.data.selfInspection}></img>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.vaccine?(
                                <div className="item">
                            <span>疫苗接种凭证：</span>
                            <div className="imgbox">
                                {
                                    this.state.data.vaccine && this.state.data.vaccine.map((res)=>(
                                        <img onClick={()=>{this.setState({modal:true,imgData:res})}} src={res} className="imgData"></img>
                                    ))
                                }
                            </div>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.nucleic?(
                                <div className="item">
                            <span>核酸检测报告：</span>
                            <div className="imgbox">
                                {
                                    this.state.data.nucleic && this.state.data.nucleic.map((res)=>(
                                        <img onClick={()=>{this.setState({modal:true,imgData:res})}} src={res} className="imgData"></img>
                                    ))
                                }
                            </div>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.disinfect?(
                                <div className="item">
                            <span>车辆消毒凭证：</span>
                            <div className="imgbox">
                                {
                                    this.state.data.disinfect && this.state.data.disinfect.map((res)=>(
                                        <img onClick={()=>{this.setState({modal:true,imgData:res})}} src={res} className="imgData"></img>
                                    ))
                                }
                            </div>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.ethyl?(
                                <div className="item">
                            <span>酒精测试照片：</span>
                            <div className="imgbox">
                                {
                                    this.state.data.ethyl && this.state.data.ethyl.map((res)=>(
                                        <img onClick={()=>{this.setState({modal:true,imgData:res})}} src={res} className="imgData"></img>
                                    ))
                                }
                            </div>
                        </div>
                            ):null
                        }
                        {
                            this.state.data.qrcode?(
                                <div className="item">
                                <span>健康码：</span><img className="imgData" onClick={()=>{
                                this.setState({modal:true,imgData:this.state.data.qrcode})
                            }} src={this.state.data.qrcode}></img>
                        </div>
                            ):null
                        }
                        <div className="item"><span>说明：</span>{this.state.data.explain}</div>
                        <div className="item"><span>上传时间：</span>{this.state.data.createDate}</div>
                        <div className="item"><span>体温：</span>{this.state.data.temperature}</div>
                        <div className="item"><span>健康码状态：</span>{this.state.data.qrcodeStatus}</div>
                    {
                        this.state.data.status == 0 ? 
                        <div>
                            <TextareaItem
                                title="备注："
                                placeholder='请输入内容'
                                value={this.state.note}
                                onChange={val => {
                                    this.setState({note:val})
                                }}
                                rows={3}
                            />
                            <div className="btnClick">
                                <button className="bohui" onClick={()=>this.submitBtn2()}>驳回</button> 
                                <button onClick={()=>this.submitBtn()}>审核</button> 
                            </div>
                        </div>
                        : <div className="item"><span>备注：</span>{this.state.data.note}</div>

                    }
                    </div>
                </div>
                <Modal
                    visible={this.state.modal}
                    transparent
                    onClose={()=>this.setState({modal:false})}
                >
                    <img className="bigimage" src={this.state.imgData}></img>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/AuditInspection/AuditDetail/index.js